module.exports = __webpack_public_path__ + "img/indexBg0216.b3fb62a6.png";